import * as React from 'react';
import { SVGProps } from 'react';

const IconSmileStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.956 6.768a2.01 2.01 0 0 0 .734-.68l.832.537a3 3 0 0 1-5.066-.035l.84-.525a2.01 2.01 0 0 0 2.66.703ZM4 4H3v1h1V4ZM6 4h1v1H6V4Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5A5 5 0 1 1 0 5a5 5 0 0 1 10 0ZM9 5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
    />
  </svg>
);
export default IconSmileStrokedSizeXs;
